const { REACT_APP_CONFIG_ENV } = process.env;

export const curentEnv = REACT_APP_CONFIG_ENV;

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const isLocal = (typeof window !== 'undefined' && window.location.hostname === 'localhost')
                      || (typeof process !== 'undefined' && process.env.REACT_APP_CONFIG_ENV === 'local');

// running app locally, but using development API
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const isLocalDev = REACT_APP_CONFIG_ENV === 'development' && isLocal;

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const isDevelopment = REACT_APP_CONFIG_ENV === 'development';

// running app locally, but using staging API
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const isLocalStaging = REACT_APP_CONFIG_ENV === 'staging' && isLocal;

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const isStaging = REACT_APP_CONFIG_ENV === 'staging';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const isProd = REACT_APP_CONFIG_ENV === 'production';

// connect to external API by Setting to true and defining the api env bellow
export const CONNECT_TO_EXTERNAL_API = !!process.env.REACT_APP_CONFIG_USE_EXTERNAL_API;

export const ADMIN_RATE_SCHEDULES_ENABLED = true;
export const ADMIN_DISABLE_SUB_CANCEL_REASON = isLocal; // why only local?
export const ENABLE_PENDING_MENU_NOTIFICATIONS = false;
export const ENABLE_INTAKE_PARTNER_SELECTION = true;
export const ADMIN_LANE_DELETE_ENABLED = isLocal;
export const ADMIN_VIOLATION_OPERATOR_FILTER_ENABLED = false;
export const ADMIN_ALLOW_DELETE_GATES = isDevelopment || isLocal;
export const ADMIN_PARKING_PASS_LOCATIONS = false;
export const ENABLE_RUM = false;
export const ENABLE_RUM_CUSTOMER_ONLY = true;
export const SPECIALIST_VALET_TIMER = false;
export const HIDE_NEW_VEND_GATE = false;
export const ENABLE_SUPER_ADMIN_CHECK = true;
export const DISPLAY_ONBOARIND_PERCENT_ENTERPRISE = isDevelopment || isLocal;
export const ENABLE_BOULDER_RATES = true;
export const SHOW_VALET_LP_SELECT = false;
export const ENABLE_LANE_EVENTS = isLocal || isDevelopment;
export const NEW_INVOICE_FLOW = true;
export const HIDE_PAST_PAYMENTS = isProd;
export const ENABLE_EXIT_BY_INPUT = true;
export const SHOW_CREATE_INVOICE_BUTTON = isLocal || isDevelopment;
export const USE_NEW_INVOICE_PREVIEW = isLocal;

export const Flags = {
  ADMIN_RATE_SCHEDULES_ENABLED,
  ADMIN_DISABLE_SUB_CANCEL_REASON,
  ENABLE_PENDING_MENU_NOTIFICATIONS,
  ENABLE_INTAKE_PARTNER_SELECTION,
  ADMIN_LANE_DELETE_ENABLED,
  ADMIN_VIOLATION_OPERATOR_FILTER_ENABLED,
  ADMIN_ALLOW_DELETE_GATES,
  ADMIN_PARKING_PASS_LOCATIONS,
  ENABLE_RUM,
  ENABLE_RUM_CUSTOMER_ONLY,
  SPECIALIST_VALET_TIMER,
  HIDE_NEW_VEND_GATE,
  ENABLE_SUPER_ADMIN_CHECK,
  DISPLAY_ONBOARIND_PERCENT_ENTERPRISE,
  REACT_APP_CONFIG_ENV,
  ENABLE_BOULDER_RATES,
  SHOW_VALET_LP_SELECT,
  ENABLE_LANE_EVENTS,
  NEW_INVOICE_FLOW,
  ENABLE_EXIT_BY_INPUT,
  HIDE_PAST_PAYMENTS,
  SHOW_CREATE_INVOICE_BUTTON,
  USE_NEW_INVOICE_PREVIEW,
};
